import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { UserResponse } from '../models/responses/user-response';
import { Observable } from 'rxjs';
import { SendSubaccountCreationLink } from '../models/requests/send-subaccount-creation-request';

@Injectable({
  providedIn: 'root'
})
export class SubaccountService {

  constructor(private httpClient: HttpClient) { }

  listSubAccounts(): Observable<UserResponse[]> {
    return this.httpClient.get<UserResponse[]>(`${environment.userUrl}/fetchSubAccounts`);
  }

  createSubAccountLink(request:SendSubaccountCreationLink): Observable<void> {
    return this.httpClient.post<void>(`${environment.userUrl}/sendSubaccountLink`,request);
  }
}
